import React from 'react'
import CompareTemplate from 'src/components/template/compare'
import { coxData } from 'src/components/template/compare/components/data/coxData'

export default (props) => <CompareTemplate location={props.location} data={coxData} />
